import { z } from "zod";
export const numberSchema = z.object({
    e164Number: z
        .string()
        .nonempty("Phone number is required")
        .startsWith("+1", "Phone number must start with +1"),
    friendlyName: z.string().nonempty("Friendly name is required"),
    country: z.string().nonempty("Country is required"),
    region: z.string().optional(),
    locality: z.string().optional(),
    voiceUrl: z
        .string()
        .url("Please enter a valid URL")
        .optional()
        .or(z.literal("")),
    source: z.enum(["twilio", "telnyx"]).default("twilio"),
    companyId: z.string().nullable(),
    externalId: z.string().optional(),
    boughtAt: z.string().optional(),
});
